import { createSelector } from "@reduxjs/toolkit";

import { IUserHomeBase } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";
import { buildSingleItem } from "shared/utils";
import { dataSelector, buildData } from "../helpers";

export const userHomeBasesSelector = createSelector(
  dataSelector,
  data => buildData(data as any, IDataKeys.userHomeBase) as IUserHomeBase[]
);

const dataUserHomeBasesSelector = createSelector(dataSelector, data => data.userHomeBase);

export const userHomeBaseSelectorCreator = (id: string) =>
  createSelector(dataUserHomeBasesSelector, data => {
    const item = data?.[API_ENDPOINTS.USER_HOME_BASE(id)];
    return item ? buildSingleItem(item) : undefined;
  });
